import React, { useEffect } from 'react';

function setStatsIFrameStyle() {
    const boundRectMenu = document.querySelector(".cg-menuTabMobile").getBoundingClientRect();
    const betslipBottomBar = document.querySelector(".betslip-bottom-bar");
    let boundRectBetslipBar = null;
    let paddingBottom = 0;
    if (betslipBottomBar != null) {
        boundRectBetslipBar = betslipBottomBar.getBoundingClientRect();
        paddingBottom = boundRectMenu.height + boundRectBetslipBar.height;
    }
    
    const statsIframe = document.querySelector("#stats-iframe");
    if (statsIframe) {
        document.querySelector("#stats-iframe").style.paddingBottom = `${paddingBottom}px`;
    }
}

function Stats(props) {
    useEffect(function() {
        setStatsIFrameStyle();
    });

    return (
        <div className="overlay">
            {/* <div className="overlay-close-button" onClick={props.close}>
                <i className="fa fa-times"></i>
            </div> */}
            <iframe id="stats-iframe" title="stats-iframe" src={props.url}></iframe>
        </div>
    );
}

export default Stats;